/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoTwitterIcon64Regular = forwardRef('LogoTwitterIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M50.637 11.478a1.5 1.5 0 0 0-2.274-1.956L34.4 25.75 22.484 9.992A2.5 2.5 0 0 0 20.49 9h-7.98c-2.065 0-3.24 2.36-1.994 4.008l16.299 21.556-15.452 17.958a1.5 1.5 0 1 0 2.274 1.956l15.029-17.465 12.85 16.995A2.5 2.5 0 0 0 43.51 55h7.98c2.065 0 3.24-2.36 1.994-4.008L36.25 28.198l14.387-16.72ZM43.76 52 13.515 12h6.727l30.244 40h-6.727Z" })));
});
